export const SITE_URL = 'https://sg-cabs.com';
export const PHONE_DISPLAY = '+91 75078 67648';
export const PHONE_TEL = '+917507867648';

export const dropCities = [
  {
    id: 'hyderabad', city: 'Hyderabad', state: 'Telangana', sedan: 12999, suv: 15999,
    distance: '~570 km', duration: '8–9 hours', highway: 'NH44 via Anantapur & Kurnool',
    stops: ['Chikkaballapur', 'Anantapur', 'Kurnool', 'Jadcherla'],
    image: '/hyderabad.jpeg',
    about: 'Hyderabad is one of the busiest intercity corridors from Bengaluru for IT professionals, families relocating and weekend travellers heading to Charminar, Ramoji Film City and the Old City food trail.',
  },
  {
    id: 'mysuru', city: 'Mysuru', state: 'Karnataka', sedan: 3999, suv: 5999,
    distance: '~145 km', duration: '2.5–3 hours', highway: 'Bengaluru–Mysuru Expressway (NH275)',
    stops: ['Bidadi', 'Ramanagara', 'Channapatna', 'Mandya', 'Srirangapatna'],
    image: '/mysuru.jpeg',
    about: 'Mysuru — the City of Palaces — is the most popular short getaway from Bengaluru. The new expressway makes a one way drop quick and comfortable for palace visits, Chamundi Hills, KRS Dam and onward trips to Coorg or Ooty.',
  },
  {
    id: 'chennai', city: 'Chennai', state: 'Tamil Nadu', sedan: 7999, suv: 9999,
    distance: '~350 km', duration: '6–7 hours', highway: 'NH48 / NH44 via Hosur, Krishnagiri & Vellore',
    stops: ['Hosur', 'Krishnagiri', 'Vellore', 'Sriperumbudur'],
    image: '/chennai.jpeg',
    about: 'Chennai is a smooth four-lane drive from Bengaluru. Our one way drop is ideal for airport connections, hospital visits, business trips and families travelling with luggage who prefer a door-to-door ride over train or bus.',
  },
  {
    id: 'coimbatore', city: 'Coimbatore', state: 'Tamil Nadu', sedan: 5999, suv: 7999,
    distance: '~365 km', duration: '6–7 hours', highway: 'NH44 & NH544 via Hosur, Krishnagiri & Salem',
    stops: ['Hosur', 'Krishnagiri', 'Dharmapuri', 'Salem', 'Avinashi'],
    image: '/coimbatore.jpeg',
    about: 'Coimbatore is the gateway to Isha Yoga Center (Adiyogi), Ooty and Valparai. A one way cab lets you travel overnight or early morning on your own schedule with a professional driver.',
  },
  {
    id: 'tirupati', city: 'Tirupati', state: 'Andhra Pradesh', sedan: 7999, suv: 9999,
    distance: '~250 km', duration: '5–6 hours', highway: 'NH75 / NH69 via Kolar & Chittoor',
    stops: ['Hoskote', 'Kolar', 'Palamaner', 'Chittoor'],
    image: '/tirupati.jpeg',
    about: 'Tirupati and the Tirumala Venkateswara temple draw thousands of devotees from Bengaluru every week. Our drivers know the darshan timings, parking rules and the Tirumala ghat road well.',
  },
  {
    id: 'goa', city: 'Goa', state: 'Goa', sedan: 13999, suv: 15999,
    distance: '~560 km', duration: '10–11 hours', highway: 'NH48 via Tumakuru, Chitradurga & Hubballi',
    stops: ['Tumakuru', 'Chitradurga', 'Davanagere', 'Hubballi', 'Belagavi'],
    image: '/goa.jpeg',
    about: 'Goa is the classic long-weekend road trip from Bengaluru. Skip the connecting flights and bus changes — a one way SUV drop gets your group and luggage straight to your North or South Goa stay.',
  },
];

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const routePages = dropCities.flatMap((c) => [
  { ...c, reverse: false, slug: `bangalore-to-${c.id}-cab`, origin: 'Bangalore', destination: c.city },
  { ...c, reverse: true, slug: `${c.id}-to-bangalore-cab`, origin: c.city, destination: 'Bangalore' },
]);

export const getRoutePage = (slug) => routePages.find((p) => p.slug === slug);

const zones = {
  north: { label: 'North Bengaluru', airportTime: '30–60 minutes', note: 'one of the closest zones to Kempegowda International Airport' },
  east: { label: 'East Bengaluru', airportTime: '60–90 minutes', note: 'well connected to the airport via Hennur Road and the Outer Ring Road' },
  south: { label: 'South Bengaluru', airportTime: '90–120 minutes', note: 'an early pickup is recommended for morning flights' },
  west: { label: 'West Bengaluru', airportTime: '75–110 minutes', note: 'connected to the airport via Tumakuru Road and the NICE Road' },
  central: { label: 'Central Bengaluru', airportTime: '60–90 minutes', note: 'with quick access to Bellary Road and the airport flyover' },
};

const areaList = [
  ['Whitefield', 'east'], ['Koramangala', 'south'], ['Indiranagar', 'central'], ['HSR Layout', 'south'],
  ['Electronic City', 'south'], ['Marathahalli', 'east'], ['Sarjapur Road', 'south'], ['Bellandur', 'east'],
  ['Hebbal', 'north'], ['Yelahanka', 'north'], ['Jayanagar', 'south'], ['JP Nagar', 'south'],
  ['BTM Layout', 'south'], ['Banashankari', 'south'], ['Rajajinagar', 'west'], ['Malleshwaram', 'central'],
  ['Hennur', 'north'], ['KR Puram', 'east'], ['Mahadevapura', 'east'], ['Devanahalli', 'north'],
  ['RR Nagar', 'west'], ['Kengeri', 'west'],
];

export const areaPages = areaList.map(([name, zone]) => ({
  name,
  zone: zones[zone],
  slug: `airport-taxi-${slugify(name)}`,
}));

export const getAreaPage = (slug) => areaPages.find((p) => p.slug === slug);

export const formatInr = (n) => `₹${n.toLocaleString('en-IN')}`;
